export const EMessageTypes = {
  DEFAULT_MESSAGE: 'default_message',
  ORGANISATION_MESSAGE: 'organisation_message',
  ORGANISATION_ACTOR_MESSAGE: 'organisation_actor_message',
  BIRTHDAY_MESSAGE: 'birthday_message',
  WELCOME_MESSAGE: 'welcome_message',
  RECOGNITION_MESSAGE: 'recognition_message',
};

export const EObjectTypes = {
  MESSAGE: 'feed_message',
  ORGANISATION_MESSAGE: 'organisation_message',
  EXCHANGE: 'exchange',
  POLL: 'poll',
  ATTACHMENT: 'attachment',
  RECOGNITION_MESSAGE: 'recognition_message',
};

export const ETimelineTypes = {
  FEED: 'feed',
  NETWORK: 'network',
  TEAM: 'team',
  ORGANISATION: 'organisation',
  CHANNEL: 'channel',
  EVENT: 'event',
  ORGANIZATION_GROUP: 'organization-group',
  NETWORK_GENERAL: 'network-general',
};

export const EFeedFilterTypes = {
  IMPORTANT: 'important',
  IMPORTANT_UNREAD: 'important_unread',
  UNREAD: 'unread',
  NONE: 'none',
};

export const EFeedSortTypes = {
  LAST_ACTIVITY: 'last_activity',
  LAST_CREATED: 'last_created',
};
